<lib-map [includeSectionItems]="true"
[includeBasemap]="true"
[initialRotation]="0"
></lib-map>